import React from 'react';
import { Button, Tooltip } from 'antd';
import { MdArrowUpward, MdArrowDownward } from 'react-icons/md';

export default function UnscheduledLocationHeading({ group, index, count, onMove }) {
  return <li className="pp-pool-location-heading">
    <h4>{group.label}</h4>
    <span className="pp-pool-location-controls">
      <Tooltip title="Move location group up"><Button type="text" icon={<MdArrowUpward/>} aria-label={`Move location group ${group.label} up`} disabled={index === 0} onClick={() => onMove(group.key, -1)}/></Tooltip>
      <Tooltip title="Move location group down"><Button type="text" icon={<MdArrowDownward/>} aria-label={`Move location group ${group.label} down`} disabled={index === count - 1} onClick={() => onMove(group.key, 1)}/></Tooltip>
    </span>
  </li>;
}